import moment from 'moment';
import 'moment/locale/fa';
import React, { useContext, useEffect, useState } from 'react';
import ChooseLanguage from '../../functions/chooseLanguage';
import TimeFunction from '../../functions/TimeFunction';
import Cookies from 'js-cookie';
import { AdminContext } from '../../context/AdminContext';

const DateComponent = ({ createdAt, className }) => {
  const { lang } = useContext(AdminContext);
  // const [lang, setLang] = useState('fa');
  useEffect(() => {
    // if (Cookies.get('ochattLang') != undefined) {
    //   setLang(Cookies.get('ochattLang'));
    // }
  }, [createdAt, lang]);
  // return <>{moment(createdAt).fromNow()}</>;
  return <p className={`${className}`}>{TimeFunction(createdAt, lang)}</p>;
};

export default DateComponent;
